var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterBadge(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 166 166",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#twitter-badge_svg__filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    x: 50,
    y: 35,
    fill: "#fff",
    rx: 20
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1DA1F2",
    fillRule: "evenodd",
    d: "M96.714 59.612a11.563 11.563 0 01-2.746 2.87 15.975 15.975 0 01-.627 5.182 16.221 16.221 0 01-1.958 4.272 16.72 16.72 0 01-3.127 3.618c-1.21 1.048-2.667 1.885-4.373 2.51-1.707.624-3.532.936-5.475.936-3.063 0-5.865-.83-8.408-2.492.395.046.836.069 1.322.069 2.543 0 4.808-.791 6.797-2.372a5.29 5.29 0 01-3.186-1.109A5.428 5.428 0 0173 70.355a6.84 6.84 0 001.034.086c.486 0 .966-.063 1.441-.19-1.266-.263-2.314-.902-3.144-1.916-.83-1.014-1.246-2.191-1.246-3.532v-.069c.768.436 1.593.67 2.475.705a5.519 5.519 0 01-1.78-1.976 5.47 5.47 0 01-.661-2.647c0-1.009.248-1.943.746-2.802a15.563 15.563 0 004.992 4.1 15.09 15.09 0 006.297 1.71 6.249 6.249 0 01-.136-1.272c0-1.536.534-2.845 1.602-3.928C85.688 57.541 86.979 57 88.493 57c1.582 0 2.916.584 4 1.753 1.232-.24 2.39-.687 3.476-1.34-.419 1.317-1.221 2.337-2.407 3.059a10.793 10.793 0 003.152-.86z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "twitter-badge_svg__filter0_d",
    width: 166,
    height: 166,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.113725 0 0 0 0 0.631373 0 0 0 0 0.94902 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterBadge);
export default "/_next/static/images/9ef0bfa480b0d78932f7b51359a6df4d.svg";
export { ForwardRef as ReactComponent };